import React from 'react';

import {
  useTranslation
} from 'react-i18next';

import HeaderLogo from '../../../resources/public/wzb-logo.png';

import './index.less';

export type HeaderProps = React.ComponentProps<'header'>;

export const Header: React.FC<Partial<HeaderProps>> = ({
  ...passThroughProps
}): JSX.Element => {

  const {
    t
  } = useTranslation();

  return (
    <header
      className="header"
      {...passThroughProps}
    >
      <div
        className="header-logo"
      >
        <img
          className="header-logo-img"
          src={HeaderLogo}
        />
      </div>
      <div
        className="header-space"
      />
      <div
        className="header-title"
      >
        <span>
          {t('Header.title')}
        </span>
      </div>
      <div
        className="header-space"
      />
    </header>
  );
};

export default Header;
